import createAPI from "@/common/createApi.js"
/**
 * config: 接口参数，
 * vconfig: （自定义参数）{
 *  neverLoading: 是否显示loading
 * }
 */
export default {
  // 查询审计日志列表
  getLogList: (realmName, config) =>
    createAPI(`/idaas/admin/realms/${realmName}/events/loginEvents`, "get", config),
}
